import { createTranslations } from '@npco/utils-translations'

export const setupFlowOverviewStageTranslations = createTranslations({
  badge: 'Overview',
  title: 'Get a snapshot of your business performance.',
  description:
    'See how your business is tracking with easy-to-understand graphs, and summaries of your most recent transactions.',
  point1: 'Real-time business performance reporting',
  point2: 'Make informed financial decisions',
  point3: 'Compare daily, monthly and weekly performance',
  point4: 'Quick links to frequently-used features',
  animationDataFilenameSmall: 'setup-flow-overview-small',
  animationDataFilenameMedium: 'setup-flow-overview-medium',
  animationDataFilenameLarge: 'setup-flow-overview-large',
})
